export const tariffTypes: string[] = ['Base', 'Technical', 'Modifier'];

export const currencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'CAD',
  currencyDisplay: 'narrowSymbol',
});

export type ClaimFieldOption = {
  label: string;
  value: string;
  disabled?: boolean;
};

type Translate = (key: string, defaultValue?: string) => string;

export const splitOptions: ClaimFieldOption[] = [
  { label: 'None', value: ' ' },
  { label: 'A - Admission', value: 'A' },
  { label: 'C - CTU', value: 'C' },
  { label: 'D - Covid/CTU Ward Services', value: 'D' },
  { label: 'E - Equal', value: 'E' },
  { label: 'G - General Anesthetic', value: 'G' },
  { label: 'H - Supportive Care (78520)', value: 'H' },
  { label: 'K - Medical Exemption/Covid Vaccine', value: 'K' },
  { label: 'L - Less Than Standard Rate', value: 'L' },
  { label: 'N - Non-Union', value: 'N' },
  { label: 'P - Pandemic', value: 'P' },
  { label: 'S - Split Surgeries', value: 'S' },
  { label: 'T - Triage', value: 'T' },
  { label: 'U - Virtual Chronic Pain (78570)', value: 'U' },
  { label: 'V - Virtual Chronic Pain (78571)', value: 'V' },
  { label: 'W - Virtual Geriatric Consult (78571)', value: 'W' },
  { label: 'X - Virtual Anesthetic Consult (78516)', value: 'X' },
  { label: '1 - Personal Care Home Resident', value: '1' },
  { label: '2 - Health Care Worker', value: '2' },
  { label: '3 - Community With Disease Impact', value: '3' },
  { label: '4 - Congregate Living, Other', value: '4' },
  { label: '5 - Routine (Age-Based)', value: '5' },
  { label: '6 - Essential Worker', value: '6' },
  { label: '7 - Pre-existing Condition', value: '7' },
];

export const incisionOptions: ClaimFieldOption[] = [
  { label: 'None', value: '' },
  { label: 'Bilateral', value: 'B' },
  { label: 'Different Incision', value: 'D' },
  { label: 'Same Incision', value: 'S' },
];

const skSplitOptions = (translate: Translate): ClaimFieldOption[] => [
  {
    label: translate('pages:claims.provinceFields.none', 'None'),
    value: ' ',
  },
];

const skIncisionOptions = (translate: Translate): ClaimFieldOption[] => [
  {
    label: translate('pages:claims.provinceFields.none', 'None'),
    value: '',
  },
  {
    label: translate('pages:claims.provinceFields.left', 'Left'),
    value: 'L',
  },
  {
    label: translate('pages:claims.provinceFields.right', 'Right'),
    value: 'R',
  },
  {
    label: translate('pages:claims.provinceFields.bilateral', 'Bilateral'),
    value: 'B',
  },
];

export const getSplitOptions = (
  province: string | null | undefined,
  translate: Translate
): ClaimFieldOption[] =>
  province?.toUpperCase() === 'SK' ? skSplitOptions(translate) : splitOptions;

export const getIncisionOptions = (
  province: string | null | undefined,
  translate: Translate
): ClaimFieldOption[] =>
  province?.toUpperCase() === 'SK'
    ? skIncisionOptions(translate)
    : incisionOptions;

export const getSplitFieldLabel = (
  _province: string | null | undefined,
  translate: Translate
): string => translate('pages:claims.provinceFields.splitFee', 'Split Fee');

export const getIncisionFieldLabel = (
  province: string | null | undefined,
  translate: Translate
): string =>
  province?.toUpperCase() === 'SK'
    ? translate(
        'pages:claims.provinceFields.bilateralIndicator',
        'Bilateral Indicator'
      )
    : translate('pages:claims.provinceFields.incision', 'Incision');

export const hospitalCarePremium = new Set([
  '8300',
  '8301',
  '8302',
  '8303',
  '8304',
  '8305',
  '8306',
  '8307',
  '8308',
  '8409',
  '8410',
  '8411',
  '8412',
  '8413',
  '8444',
  '8445',
  '8446',
  '8452',
  '8466',
  '8467',
  '8468',
  '8477',
  '8490',
  '8502',
  '8503',
  '8504',
  '8508',
  '8510',
  '8512',
  '8520',
  '8524',
  '8526',
  '8536',
  '8540',
  '8543',
  '8544',
  '8550',
  '8551',
  '8553',
  '8554',
  '8556',
  '8557',
  '8581',
  '8584',
  '8594',
  '8595',
  '8596',
  '8599',
  '8614',
  '8615',
  '8617',
  '8620',
  '8622',
  '8623',
  '8624',
  '8625',
  '8626',
  '8635',
  '8645',
  '8646',
  '8647',
  '8660',
  '8662',
  '8663',
  '8664',
  '8667',
  '8704',
  '8706',
  '8707',
  '8708',
  '8732',
  '8733',
]);

export const afterHoursTariffCodes = new Set([
  '5550',
  '5553',
  '5555',
  '5556',
  '5557',
  '5558',
]);
